export default __webpack_public_path__ + "static/media/pot3.f5737ada.svg";